<div class="sports-container" id="sports-anchor" [ngStyle]="{ backgroundImage: 'linear-gradient(170deg, transparent 60%, white 100%)', backgroundColor: getSelectedBackgroundColor() }">
  <div class="content-description">
    <h2 class="shadowed-header">My Sports</h2>
  </div>
  <div *ngIf="selectedSport === null" class="sports">
    <div *ngFor="let sport of sports; index as i" ngClass="sport{{ i }}">
      <div class="sportContent" [ngStyle]="{ background: getBackgroundColor(sport) }" (click)="selectSport(sport)">
        <div class="sportsSportHeader">{{ sport.name }}</div>
        <div class="sportSquare">
          <img src="{{ sport.imagePath }}" />
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="selectedSport !== null">
    <div class="sportsBackButtonContainer">
      <button mat-fab color="primary" (click)="unselectSport()">
        <mat-icon aria-hidden="false">arrow_back</mat-icon>
      </button>
    </div>
    <div class="selectedSportContainer">
      <div class="selectedSportInfoContainer">
        <div class="sport-header"><p>{{ selectedSport.name }}</p></div>
        <div class="sport-description" [innerHtml]="selectedSport.descriptionHtml"></div>
      </div>
      <div class="selectedSportSquareContainer">
        <div (click)="unselectSport()" class="selectedSquare">
          <img src="{{ selectedSport.imagePath }}" />
        </div>
      </div>
    </div>
  </div>
</div>
